var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
let SimpleSection = class SimpleSection extends LitElement {
    constructor() {
        super(...arguments);
        this.title = 'Title';
        this.collapsed = false;
    }
    toggleCollapse() {
        this.collapsed = !this.collapsed;
    }
    render() {
        return html `
      <basic-card>
        <div class="section-header" @click=${this.toggleCollapse}>
          <span>${this.title}</span>
          <span>${this.collapsed ? '▶' : '▼'}</span>
        </div>
        ${!this.collapsed
            ? html `<slot></slot>`
            : ''}
      </basic-card>
    `;
    }
};
SimpleSection.styles = css `
    .section-header {
      font-weight: bold;
      cursor: pointer;
      user-select: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1rem;
      margin-bottom: 16px;
    }
  `;
__decorate([
    property({ type: String })
], SimpleSection.prototype, "title", void 0);
__decorate([
    state()
], SimpleSection.prototype, "collapsed", void 0);
SimpleSection = __decorate([
    customElement('simple-section')
], SimpleSection);
export { SimpleSection };
//# sourceMappingURL=SimpleSection.js.map